<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="BEP" id="_idParaDest-3"><span class="Italic">I do not pretend to understand the moral universe, the arc is a long one, my eye reaches but little ways. I cannot calculate the curve and complete the figure by the experience of sight; I can divine it by conscience. But from what I see I am sure it bends towards justice.</span></p>
<p class="BEPC">—Theodore Parker, “Of Justice and Conscience,” 1853</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?61dbd3bc